import { createApi } from '@reduxjs/toolkit/query/react';
import { getBaseQuery } from './getBaseQuery';
import { GetUserNotificationRequest, GetUserNotificationResponse, PatchNotificationRequest, PatchNotificationResponse } from './types/TNotificationServices';

const URL_Prefix = '/notification';

export const notificationService = createApi({
    reducerPath: 'notificationService',
    baseQuery: getBaseQuery,
    tagTypes: ['Notification'],
    endpoints: (builder) => ({
         getUserComment: builder.query<GetUserNotificationResponse, GetUserNotificationRequest>({
              query: (params) => ({
                url: `${URL_Prefix}/user_notifications/`,
                method: 'GET',
                params: params
              }),
              providesTags: ['Notification'],
            }),
         patchNotification: builder.mutation<PatchNotificationResponse, PatchNotificationRequest>({
              query: (body) => ({
                url: `${URL_Prefix}/${body.uuid}/`,
                method: 'PATCH',
                body: body
              }),
              invalidatesTags: ['Notification'],
            }),
    }),
});

export const {
   useGetUserCommentQuery,
   useLazyGetUserCommentQuery,
   usePatchNotificationMutation
} = notificationService;